/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {Injectable} from '@angular/core';
import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {Observable} from 'rxjs';
import {
  CustomerDeviceListInterface,
  CustomerDevicePortSummaryInterface,
  SensorCustomVarsDtoInterface,
  SensorCustomVarDataInterface,
  SensorCustomerVarInterface,
  CustomerDeviceUtilsInterface,
  MkadCustomerDeviceInterface,
  MkadVariableDataDtoInterface,
  CustomerDeviceDetailInterface,
  CustomerDeviceUpdateDto, CustomizationAssignDeviceDTO,
} from '@shared/interface/settings/device/customer-device/customer-device.interface';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MkadCustomerDeviceService extends MkadBaseService {
  readonly customer = URLS_SERVICE.meerkad.customer;
  readonly device = URLS_SERVICE.meerkad.device;
  readonly core = URLS_SERVICE.core;
  readonly deviceModel = URLS_SERVICE.devices.deviceModelPort;
  readonly customerSensor = URLS_SERVICE.devices.customerDeviceSensor;
  readonly enumVarLimit = URLS_SERVICE.devices.enumCustomerDeviceVarLimit;
  readonly variable = URLS_SERVICE.devices.variable;

  private customerDeviceDetail: CustomerDeviceDetailInterface | null = null;

  get customerData(): CustomerDeviceDetailInterface {
    return <CustomerDeviceDetailInterface>this.customerDeviceDetail;
  }

  /**
   * @description
   * Method that queries the trigger and rule enums listing
   */
  listEnums(): Observable<CustomerDeviceUtilsInterface> {
    return this.http.post<CustomerDeviceUtilsInterface>(this.baseCore + this.enumVarLimit.base + this.enumVarLimit.data);
  }

  /**
   * @description
   * Method that queries the nested summary port customer device
   */
  summaryPort(param: MkadCustomerDeviceInterface): Observable<CustomerDevicePortSummaryInterface[]> {
    return this.http.post<CustomerDevicePortSummaryInterface[]>(this.core.base + this.deviceModel.base + this.deviceModel.data, param);
  }

  /**
   * @description
   * Method that queries the nested summary port customer device
   */
  summarySensor(param: SensorCustomVarsDtoInterface): Observable<SensorCustomVarDataInterface> {
    return this.http.post<SensorCustomVarDataInterface>(this.core.base + this.customerSensor.base + this.customerSensor.data, param);
  }

  /**
   * @description
   * Method that queries the nested list customer device
   */
  list(): Observable<CustomerDeviceListInterface[]> {
    return this.http.post<CustomerDeviceListInterface[]>(this.customer.base + this.device.base + this.device.list);
  }

  /**
   * @description
   * Method that updated the customization device
   */
  customize(data: CustomerDeviceUpdateDto): Observable<CustomerDeviceUpdateDto> {
    return this.http.post<CustomerDeviceUpdateDto>(this.customer.base + this.device.base + this.device.update, data);
  }

  /**
   * @description
   * Method that queries the customer device by id
   */
  get(param: number): Observable<CustomerDeviceDetailInterface> {
    return this.http.post<CustomerDeviceDetailInterface>(this.customer.base + this.device.base + this.device.get, {id: param})
      .pipe(map((response: CustomerDeviceDetailInterface) => {
        this.customerDeviceDetail = {...response};
        return response;
      }));
  }

  /**
   * @description
   * Method that queries the no customized data variable by id
   */
  getNoCustomiseVariable(param: MkadVariableDataDtoInterface): Observable<SensorCustomerVarInterface> {
    return this.http.post<SensorCustomerVarInterface>(this.baseCore + this.variable.base + this.variable.data, param);
  }

  /**
   * @description
   * Method that updated the customization device
   */
  register(data: CustomizationAssignDeviceDTO): Observable<any> {
    return this.http.post<any>(this.customer.base + this.device.base + this.device.register, data);
  }
}
